import { ReactNode } from "react";

export type PrimaryChargeQuickPayOption =
  | "you_pay_for_everyone"
  | "everyone_pays_for_themselves"
  | "custom";

export type EventSignUpProcessSteps =
  | "PEOPLE"
  | "FORM"
  | "PRIMARY_CHARGE_SELECTION"
  | "PRIMARY_CHARGE_WHO_PAYS";

export type EventSignUpRow = {
  id: string | null;
  checkedIn: CheckInStatus;
  waitlistIndex: number | null;
  registrations: EventSignUpRegistration[];
  tempID?: null | string;
  isDirty?: boolean;
  ownerClient?: {
    id: string;
    firstName: string;
    lastName: string;
    profileImagePublicId?: string;
  };
  paymentCardOnFileId?: string | null;
};

export type EventSignUpRegistration = {
  id: string | null;
  index: number | null;
  type: "GUEST" | "MEMBER" | "New Guest" | "CUSTOMER" | null;
  registrant: EventPlayer;
  formResponses?: EventFormResponseInput[];
  payingMemberId: string;
  payingCustomerId?: string;
  primaryRegistrationChargeTypeId: string | null;
  primaryRegistrationChargeTypeDisplayName?: string | null;
  primaryRegistrationChargeTypeDisplayDescription?: string | null;
  unknownRegistrantDisplayName?: string | null;
};

export type EventPlayer = {
  id?: string | null;
  playerId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  detail?: string;
  profileImage?: {
    publicId: string;
  } | null;
  phoneNumber?: string | null;
  ghinNumber?: number | null;
};

//TODO: These types are reflected from GRAPHQL - we need to write something that will
//generate them and then just import them.
export type EventFormResponseInput = {
  booleanValue?: boolean | null;
  eventRegistrationId?: string | null;
  questionConfigurationId: string;
  stringValue?: string | null;
  transportationTypeId?: string | null;
};

export type CheckInStatus = "CHECKED_IN" | "NONE" | "NO_SHOW";

export type AddPeopleRenderFunction = (args: {
  isGroupFullOfGuests: boolean;
  isGroupFullOfMembers: boolean;
  isGroupFullOfAttendees: boolean;
  isGroupFullOfCustomers: boolean;
  selectedPlayerIds: string[];
  searchString: string;
  unknownGuestCount: number;
  memberHoldCount: number;
  memberCount: number;
  guestCount: number;
  customerCount?: number;
  currentRegistrations: EventSignUpRegistration[];
  setSearchString: (searchString: string) => void;
  handleAddMemberClick: (player: EventPlayer, checked: boolean) => void;
  handleAddGuestClick: (player: EventPlayer, checked: boolean) => void;
  handleNewGuestSubmission: (guest: EventPlayer) => void;
  handleAddUnknownGuestClick: () => void;
  handleAddMemberHoldClick: () => void;
  handleRemoveMemberHoldClick: () => void;
  handleRemoveUnknownGuestClick: () => void;
  handleAddCustomerClick: (customer: EventPlayer, checked: boolean) => void;
  handleAddUnknownCustomerClick: () => void;
  handleRemoveUnknownCustomerClick?: () => void;
  handleRemovePlayerClick?: (playerId: string) => void;
  notifyMembers: boolean;
  setNotifyMembers: (notifyMembers: boolean) => void;
  /** Rendered just below the search input (e.g. capacity warnings). */
  listHeaderComponent?: ReactNode;
}) => ReactNode;

export type UnknownGuestPrimaryChargePaymentMap = {
  payerId: string;
  unknownGuestCount: number;
  primaryChargeId: string | null;
};
